<div class="filter-container">
  <va-filtered-mat-table
    #table
    [tableDataService]="dataService"
    [preselectedRows]="preselectedPackagesWithPrices"
    [limitContentHeightForDesktop]="false"
  ></va-filtered-mat-table>
</div>
